import { render, staticRenderFns } from "./gantt-milestone.vue?vue&type=template&id=566f137e&scoped=true&"
import script from "./gantt-milestone.vue?vue&type=script&lang=ts&"
export * from "./gantt-milestone.vue?vue&type=script&lang=ts&"
import style0 from "./gantt-milestone.vue?vue&type=style&index=0&id=566f137e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f137e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566f137e')) {
      api.createRecord('566f137e', component.options)
    } else {
      api.reload('566f137e', component.options)
    }
    module.hot.accept("./gantt-milestone.vue?vue&type=template&id=566f137e&scoped=true&", function () {
      api.rerender('566f137e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/gantt/components/gantt-milestone.vue"
export default component.exports